import { IconChevronsRight as TablerIconChevronsRight } from '@tabler/icons-react';

import { createOutlineIcon } from '@/components/icon/createOutlineIcon';

export const IconChevronsRight = /*#__PURE__*/ createOutlineIcon(
  TablerIconChevronsRight,
  'IconChevronsRight',
);
